import {
  bottomBarHeight,
  MAX_CONTENT_WIDTH_PX,
  spacingVars,
} from '@tundr/ds-foundations';
import { style } from '@vanilla-extract/css';

export const wrapperClass = style({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  minHeight: 0,
  overflow: 'hidden',
  paddingBottom: `calc(${bottomBarHeight} + ${spacingVars.xl})`,
});

export const contentClass = style({
  flex: '1 1 auto',
  minHeight: 0,
  overflowY: 'auto',
  display: 'flex',
  justifyContent: 'center',
  padding: spacingVars.xl,
});

export const innerClass = style({
  width: '100%',
  maxWidth: MAX_CONTENT_WIDTH_PX,
});
